{
  "default": {
    "supportButton": {
      "label": "Obtener ayuda"
    }
  }
}
